<template>
    <a class="boardGalleryStyle"
       @click="boardDetailMove(boardId, data.oBoard.nBoardNum, data.oBoard.oAuthorizeAccessRead)"
    >
        <div class="flex board-list-thumb" :class="boardReadCheck(data.oBoard.nBoardNum)">
            <!-- 썸네일 -->
            <div class="board-list-thumb-img"><img width="100%" v-lazy.container="data.oBoard.strThumbUrl" /> </div>
            <div class="board-list-thumb-subject">
                <!-- 게시글 제목 -->
                <h3 :class="{ bUserBlockY: !data.oBoard.oAuthorizeAccessRead.bAuthorizeAccess }">{{ data.oBoard.strBoardTitle }}</h3>
                <div class="info userPopupInfo">
                    <span class="name" v-if="data.oUser" @click.stop="userPopupToggleClass($event,'on')">
                        {{ data.oUser.strNickName }}
                        <board-user-popup :data.sync="data" />
                    </span>
                    <!-- 게시글 등록일 -->
                    <span class="time" v-if="data.oBoard">{{ data.oBoard.strRegDate | moment("YY.MM.DD") }} </span>
                </div>
            </div>
        </div>
    </a>
</template>

<script>
    import BoardUserPopup from "@/components/boardUserPopup";
    export default {
        name: 'boardGalleryStyle',
        components: {BoardUserPopup},
        data() {
            return {
                boardId:this.storageGet('vuex','boardActiveCode'),  // 현재 게시글 카테고리
            }
        },
        props: ['data'],
        // 계산된 속성
        computed: {
        },
        // 감시자
        watch: {
        },
        // $el 생성전
        created() {
        },
        // $el 생성후
        mounted() {
        },
        methods: {
            // 게시글 새로고침
            boardReload(){
                this.$parent.boardListReload();
            }
        },
    }

</script>
<style scoped>
    .info {position: relative}
    .info.userPopupInfo .name {color: #777676;}
    .info.userPopupInfo .time{padding-left: 7px;color: #ccc;position: relative;margin-left: 10px }
    .info.userPopupInfo .time:after{content: "";background-image: url("../assets/images/icon-time.png"); width: 4px; height: 4px;background-size: 4px 4px; background-repeat: no-repeat; position: absolute; top :4px; left: 0px }

</style>
